import { useEffect } from 'react';

// This component dynamically inserts the Microsoft Clarity script into the <head> of the HTML document.
// We use this approach to keep the project ID secure and managed via environment variables,
// instead of hardcoding it directly in the index.html file.

const ClarityScript = () => {
    useEffect(() => {
        // Create a script element
        const clarityScript = document.createElement('script');
        clarityScript.type = 'text/javascript';
        clarityScript.async = true;
        clarityScript.innerHTML = `
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "${process.env.REACT_APP_CLARITY_PROJECT_ID}");
    `;
        // Append the script element to the head of the document
        document.head.appendChild(clarityScript);
    }, []);

    return null; // This component does not render anything visible
};

export default ClarityScript;
